/* eslint-disable react-hooks/exhaustive-deps */
import { useDoctorsData } from "../../../providers/doctorsData";
import { useFilters } from "../../../providers/filters";

import { useSearchParams } from "react-router-dom";
import { DropDownMenu } from "../../Modals/DropDownMenu";
import { LocalModal } from "../../Modals/LocalModal";
import { ToggleButtons } from "../Buttons/ToggleButtons";

const MainFilter = () => {

  const { insurances, searching } = useDoctorsData();
  const [searchParams, setSearchParams] = useSearchParams();

  const { localModal, setLocalModal, states } = useFilters();

  const handleToggleButtons = (value: string) => {
    let scheduType = "";
    if (value === "Presencial") scheduType = "0";
    if (value === "Vídeo") scheduType = "1";

    if (searchParams.get("scheduType") === scheduType) {
      searchParams.delete("scheduType");
    } else {
      searchParams.set("scheduType", scheduType);
    }
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);
  };

  // Atualiza URL ao trocar convênio
  const setHealthyInsuranceFilter = (insurance: string) => {
    searchParams.set("insurance", insurance.toLowerCase());
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);
  };

  return (
    <div className="main-filter">
      <div className="row g-2">
        <div className="col-12 col-md-auto">
          <p className="ms-2 mb-0 lh-1 py-2">Filtrar:</p>
        </div>
        <div className="col">
          <div className="row g-2 align-items-center">
            <div className="col col-auto">
              <button
                onClick={() => {
                  if (!searching) {
                    setLocalModal(true);
                  }
                }}
                disabled={states.length <= 0}
                className="btn btn-btn btn-outline-light d-flex-align-items-center"
              >
                <i className="las la-map-marker-alt me-2 opacity-50" />
                <span>
                  {searchParams.get("location")?.toLocaleLowerCase() ?? "Locais"}
                </span>
              </button>
            </div>
            <div className="col col-auto">
              <DropDownMenu
                theme="light"
                value={searchParams.get("insurance") ?? ""}
                setValue={setHealthyInsuranceFilter}
                icon="las la-briefcase me-2 opacity-50"
                itensList={insurances}
                label="Convênio"
              />
            </div>
            <div className="col col-auto">
              <ToggleButtons
                value={
                  searchParams.get("scheduType") === "0"
                    ? ["Presencial"]
                    : searchParams.get("scheduType") === "1"
                      ? ["Vídeo"]
                      : []
                }
                setValue={handleToggleButtons}
                theme="light"
                firstButtonName="Vídeo"
                firstButtonIcon="las la-video me-2 opacity-50"
                secondButtonName="Presencial"
                secondButtonIcon="las la-hospital me-2 opacity-50"
              />
            </div>

          </div>

        </div>
      </div>
      {localModal && <LocalModal modal={localModal} closeModal={() => setLocalModal(false)} />}
    </div>
  );
};

export default MainFilter;
